"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GroupTableReport = /*#__PURE__*/function (_Component) {
  _inherits(GroupTableReport, _Component);
  function GroupTableReport() {
    var _this;
    _classCallCheck(this, GroupTableReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, GroupTableReport, [].concat(args));
    // render table cell with a binary value
    // render comment box
    _defineProperty(_assertThisInitialized(_this), "_renderCommentBox", function (number, name, dateStr, comment) {
      if ((0, _isNil2["default"])(comment)) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentInfo
      }, /*#__PURE__*/_react["default"].createElement("h2", null, name), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("h3", null, dateStr)), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, comment));
    });
    _defineProperty(_assertThisInitialized(_this), "processTableRows", function () {
      var _this$props = _this.props,
        reportProps = _this$props.reportProps,
        data = _this$props.data;
      var tableData = [];
      if (reportProps.tableRows) {
        reportProps.tableRows.forEach(function (item) {
          var newRow = [];
          var devTag = item.dataPath;
          newRow.push(item.question);
          reportProps.responseSetLabels.forEach(function (label) {
            var hasRoleData = !(0, _isNil2["default"])(data.roles);
            if (hasRoleData) {
              var responseSetMatch = data.roles.client.metricsList.find(function (metric) {
                return metric.responseSet === label.responseSet;
              });
              if (responseSetMatch) {
                var value = responseSetMatch.devTags[devTag];
                if (value) {
                  newRow.push(value);
                } else {
                  newRow.push('');
                }
              } else {
                newRow.push('');
              }
            }
          });
          tableData.push(newRow);
        });
      }
      return tableData;
    });
    _defineProperty(_assertThisInitialized(_this), "handleResponseTimePoints", function () {
      var reportProps = _this.props.reportProps;
      var tableBody = [];
      var tableHeader = reportProps.responseSetLabels.map(function (item) {
        return item.label;
      });
      tableBody = _this.processTableRows();
      return {
        tableHeader: tableHeader,
        tableBody: tableBody
      };
    });
    return _this;
  }
  _createClass(GroupTableReport, [{
    key: "render",
    value: function render() {
      var isReport = this.props.isReport;
      var tableData = this.handleResponseTimePoints();
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].description
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: _style["default"].title
      }, this.props.reportProps.reportTitle), this.props.reportProps.description && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: this.props.reportProps.description
      })), tableData ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("table", {
        className: "".concat(_style["default"].groupTable, " table")
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        key: "header"
      }, /*#__PURE__*/_react["default"].createElement("th", {
        key: "blank",
        rowSpan: "2",
        className: _style["default"].leftAlign + ' ' + _style["default"].bottomVert
      }), tableData.tableHeader && tableData.tableHeader.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: i,
          style: {
            padding: '1em',
            textAlign: 'center',
            width: '11%'
          }
        }, ' ', item);
      })), /*#__PURE__*/_react["default"].createElement("tr", {
        className: _style["default"].numbersHeaderRow
      }), tableData.tableBody.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: i
        }, item.map(function (cell, index) {
          return /*#__PURE__*/_react["default"].createElement("td", {
            key: index,
            style: index === 0 ? {
              border: '1px solid #ccc',
              width: '35%',
              padding: '1em'
            } : {
              border: '1px solid #ccc',
              padding: '1em',
              width: '10%',
              textAlign: 'center'
            }
          }, cell);
        }));
      }))) : /*#__PURE__*/_react["default"].createElement("h2", null, "No Data Available"))))));
    }
  }]);
  return GroupTableReport;
}(_react.Component);
GroupTableReport.propTypes = {
  // the active child
  data: _propTypes["default"].object,
  // props pass through from a    ppdefs
  reportProps: _propTypes["default"].object,
  // Full rendered markup for the header
  header: _propTypes["default"].node,
  // whether to render in report page
  isReport: _propTypes["default"].bool,
  description: _propTypes["default"].string
};
var _default = exports["default"] = GroupTableReport;